import { render } from "./SondertagePopup.vue?vue&type=template&id=5d255148"
import script from "./SondertagePopup.vue?vue&type=script&lang=js"
export * from "./SondertagePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__